
import Vue from 'vue';
import { toastState, removeToast } from '@/plugins/toast';

export default Vue.extend({
  name: 'GlobalToast',

  computed: {
    toasts() {
      return toastState.toasts;
    },
  },

  methods: {
    dismiss(id: number) {
      removeToast(id);
    },

    iconFor(type: string): string {
      if (type === 'success') return '✓';
      if (type === 'error') return '✕';
      return 'ℹ';
    },
  },
});
